import { DEFAULT_CRM_SETTINGS } from './crm.js';
import { DEFAULT_DEVICE_SETTINGS } from './devices.js';
import { DEFAULT_OPERATIONS_SETTINGS } from './operations.js';

/** Order types offered at the counter. Each can be switched off per tenant. */
export const ORDER_TYPES = Object.freeze([
  { key: 'dine_in', label: 'Dine-in' },
  { key: 'takeaway', label: 'Takeaway' },
  { key: 'parcel', label: 'Parcel' },
]);
export const ORDER_TYPE_KEYS = Object.freeze(ORDER_TYPES.map((o) => o.key));

/** Where the order came from (aggregator orders are keyed in manually). */
export const ORDER_SOURCES = Object.freeze([
  { key: 'counter', label: 'Counter' },
  { key: 'self_order', label: 'Self-order' },
  { key: 'swiggy', label: 'Swiggy' },
  { key: 'zomato', label: 'Zomato' },
  { key: 'phone', label: 'Phone' },
]);
export const ORDER_SOURCE_KEYS = Object.freeze(ORDER_SOURCES.map((o) => o.key));

export const PAYMENT_MODES = Object.freeze([
  { key: 'cash', label: 'Cash' },
  { key: 'upi', label: 'UPI' },
  { key: 'card', label: 'Card' },
  { key: 'wallet', label: 'Wallet' },
  { key: 'due', label: 'Due / credit' },
  { key: 'points', label: 'Loyalty points' },
]);
export const PAYMENT_MODE_KEYS = Object.freeze(PAYMENT_MODES.map((p) => p.key));

export const REFUND_MODES = Object.freeze(['cash', 'upi', 'card', 'wallet', 'due_adjust', 'points']);

export const FOOD_TYPES = Object.freeze([
  { key: 'veg', label: 'Veg' },
  { key: 'non_veg', label: 'Non-veg' },
  { key: 'egg', label: 'Egg' },
]);
export const FOOD_TYPE_KEYS = Object.freeze(FOOD_TYPES.map((f) => f.key));

export const BILL_STATUS = Object.freeze({
  HELD: 'held',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  VOIDED: 'voided',
  PARTIALLY_REFUNDED: 'partially_refunded',
  REFUNDED: 'refunded',
});
export const BILL_STATUS_LIST = Object.freeze(Object.values(BILL_STATUS));

export const PRICE_MODES = Object.freeze(['inclusive', 'exclusive']);
export const ROUNDING_MODES = Object.freeze(['nearest', 'none', 'up', 'down']);

/** Common GST rates (basis points) offered as suggestions — any rate can be configured. */
export const GST_RATE_SUGGESTIONS_BP = Object.freeze([0, 500, 1200, 1800, 2800, 4000]);

export const DEFAULT_KITCHEN_STATION = 'kitchen';

export const DEFAULT_POS_SETTINGS = Object.freeze({
  rounding: 'nearest',
  defaultPriceMode: 'inclusive',
  invoiceFormat: '{OUTLET}/{FY}/{SEQ6}',
  creditNoteFormat: '{OUTLET}/CN{FY2}/{SEQ5}',
  orderTypes: { dine_in: true, takeaway: true, parcel: true },
  tableRequiredForDineIn: false,
  sources: { counter: true, self_order: false, swiggy: true, zomato: true, phone: true },
  discountAuditThresholdPct: 10,
  receipt: {
    headerLines: [],
    footerLines: ['Thank you! Visit again.'],
    showGstin: true,
    showFssai: true,
    showCashier: true,
    showCustomer: true,
    showTaxBreakup: true,
    showUpiQr: true,
    paperWidth: '80mm',
    // Thermal template options
    showLogo: true,
    showLinkQr: false,
    fontSize: 'normal', // 'normal' | 'large' (double-height item lines)
  },
  kot: { large: true, showCreatedBy: true },
  tokenSlip: { enabled: false, footer: 'Please wait for your token to be called' },
  printing: {
    autoPrintReceipt: true, // when a thermal receipt printer is set up (never auto-opens the browser dialog)
    autoPrintKot: true,
    openDrawerOnCash: true,
  },
  ...DEFAULT_OPERATIONS_SETTINGS,
  ...DEFAULT_CRM_SETTINGS,
  ...DEFAULT_DEVICE_SETTINGS,
});
